<sdps-modal-beta sdps-title="Cancel this transaction?" id="{{id}}">
  
  <div slot="modal-body">
    <div class="sdps-text-body modal-first-line">Are you sure you want to cancel this transaction? Cancellations cannot be undone.</div>
    <div class="sdps-text-body"><strong>Type: </strong>{{transactionToCancel.Type}}</div>
    <div class="sdps-text-body"><strong>To/From: </strong>{{transactionToCancel['To/From']}}</div>
    <div class="sdps-text-body"><strong>Amount: </strong>{{transactionToCancel.Amount}}</div>
    <div class="sdps-text-body"><strong>Process date: </strong>{{transactionToCancel['Transaction date']}}</div>
    <div class="sdps-text-body"><strong>Frequency: </strong>{{transactionToCancel.Frequency}}</div>
  </div>
  <div slot="modal-footer">
    <button (click)="onCancelClick()" type="button"
      class="sdps-button sdps-button--small sdps-button--secondary sdps-text-body">No, go back</button>
    <button (click)="onContinueClick()" type="button"
      class="sdps-button sdps-button--primary sdps-button--small sdps-text-body" id="lc_cancel_continue">Yes, cancel</button>
  </div>
</sdps-modal-beta>